export const removeDiacritics = (str, stringPrototype = String.prototype) => {
    if ('normalize' in stringPrototype) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    return str;
};
